import i18n from "i18next";
import type {
	CustomFunctionUiActionMessage,
} from "src/api/generated/erp/customFunctions/triggers/uiAction/customFunctionUiActionMessage.ts";
import { AavoMarkdown } from "src/components/common/AavoMarkdown.tsx";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import type {
	CloseDialogFunc,
	OpenGenericDialogFunc,
} from "src/components/common/dialogs/GenericDialogContext.ts";
import { AavoFormFooter } from "src/components/common/forms/AavoFormFooter.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

interface CustomFunctionUiActionMessageDialogProps {
	message: CustomFunctionUiActionMessage;
	closeDialog: CloseDialogFunc;
}

export function CustomFunctionUiActionMessageDialog({
	message,
	closeDialog,
}: CustomFunctionUiActionMessageDialogProps) {
	return (
		<VerticalBox sx={{ flex: 1, minHeight: 0 }}>
			<AavoMarkdown sx={{ flex: 1, minHeight: 0, overflow: "auto", padding: 2 }}>
				{message.content}
			</AavoMarkdown>
			<AavoFormFooter>
				<AsyncButton label={i18n.t("close")} onClick={() => closeDialog()} />
			</AavoFormFooter>
		</VerticalBox>
	);
}

export function openCustomFunctionUiActionMessageDialog(
	openDialog: OpenGenericDialogFunc,
	actionLabel: string,
	message: CustomFunctionUiActionMessage,
) {
	openDialog(({ closeDialog }) => ({
		title: message.subject?.trim() || actionLabel,
		size: "sm",
		agentContext: {
			key: defineAgentUiContextKey("customFunctions.uiActionMessageDialog"),
			data: { actionLabel },
			pathSegments: [actionLabel],
		},
		content: <CustomFunctionUiActionMessageDialog message={message} closeDialog={closeDialog} />,
	}));
}
